import { Component, inject, OnInit } from '@angular/core';
import { SharedPeerToPeerConfirmationModule } from '@pages/send-money/components/peer-to-peer-confirmation/shared-peer-to-peer-confirmation.module';
import { SharedPeerToPeerConfirmationComponent } from '@pages/send-money/components/peer-to-peer-confirmation/shared-peer-to-peer-confirmation.component';
import { PeerToPeerSuccessComponent } from '../peer-to-peer-success/peer-to-peer-success.component';
import { CustomersService } from '@lib/services/customer/customer.service';

@Component({
    standalone: true,
    selector: 'app-peer-to-peer-confirmation',
    templateUrl: './peer-to-peer-confirmation.component.html',
    styleUrls: ['./peer-to-peer-confirmation.component.scss'],
    imports: [SharedPeerToPeerConfirmationModule],
})
export class PeerToPeerConfirmationComponent extends SharedPeerToPeerConfirmationComponent implements OnInit {
    private customerService = inject(CustomersService);
    ngOnInit() {
        this.redirectToComponent = PeerToPeerSuccessComponent;
    }
}
